import 'intersection-observer'
import VueObserveVisibility from 'vue-observe-visibility'
import Vue from '../consts/vue'

Vue.use(VueObserveVisibility)
